import { isHybrid, isTouch, supportsPassiveEvents } from './device';

const $ = window.$;

/**
 * HACK: Chrome 56+ and Safari 11.3+ sets the passive option to true by default
 * on touchstart and touchmove event listeners but for the latter we need it to
 * be false for the event listener that handles horse items in the grid to be
 * able to prevent scrolling while dragging. Another approach could be to set
 * `touch-action: none` to prevent scrolling but Safari doesn't support it.
 *
 * There is no support in jQuery to set listener options per event listener so we
 * are forced to set it here for all touchmove listeners.
 *
 * See also https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners
 */
$.event.special.touchmove = {
  setup: function (data, ns, handle) {
    this.addEventListener(
      'touchmove',
      handle,
      supportsPassiveEvents ? { passive: false } : false,
    );
  },
};

const isEventTypeMapped = eventType =>
  eventType === 'down' ||
  eventType === 'up' ||
  eventType === 'move' ||
  eventType === 'cancel';

const eventTypeMap = (eventType, touch) => {
  switch (eventType) {
    case 'down':
      return touch ? 'touchstart' : 'mousedown';
    case 'up':
      return touch ? 'touchend' : 'mouseup';
    case 'move':
      return touch ? 'touchmove' : 'mousemove';
    case 'cancel':
      return touch ? 'touchcancel' : 'mousecancel';
    default:
      return;
  }
};

$.extend($.fn, {
  transform: function (transform) {
    $(this).css({
      '-webkit-transform': transform,
      '-moz-transform': transform,
      '-ms-transform': transform,
      '-o-transform': transform,
      transform: transform,
    });
  },

  event: function (type, listener) {
    const curIsTouch = isTouch();
    if (isHybrid() && isEventTypeMapped(type)) {
      $(this).unbind(eventTypeMap(type, !curIsTouch), listener);
    }
    const mappedType = eventTypeMap(type, curIsTouch) || type;
    $(this).on(mappedType, listener);
  },

  unevent: function (type, listener) {
    const curIsTouch = isTouch();
    if (isHybrid() && isEventTypeMapped(type)) {
      $(this).unbind(eventTypeMap(type, !curIsTouch), listener);
    }
    const mappedType = eventTypeMap(type, curIsTouch) || type;
    $(this).off(mappedType, listener);
  },

  reevent: function (type, listener) {
    const curIsTouch = isTouch();
    if (isHybrid() && isEventTypeMapped(type)) {
      $(this).off(eventTypeMap(type, !curIsTouch));
    }
    const mappedType = eventTypeMap(type, curIsTouch) || type;
    $(this).off(mappedType).on(mappedType, listener);
  },

  formData: function () {
    return $.deparam($.param($(this).serializeArray()));
  },

  removeClassPrefix: function (prefix) {
    const $this = $(this);
    let clss = $this.prop('class');
    if (clss) {
      clss = clss.split(' ');
      for (const cls of clss) {
        if (cls.indexOf(prefix) === 0) {
          $this.removeClass(cls);
        }
      }
    }
  },
});
